module.exports = __webpack_public_path__ + "img/hero-air-03.cfe0e560.png";